import { render, staticRenderFns } from "./allMarketplaces.vue?vue&type=template&id=37c2499b&"
import script from "./allMarketplaces.vue?vue&type=script&lang=js&"
export * from "./allMarketplaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports